import { NavigationGuard } from 'vue-router';

export const UNAVAILABLE_GUARD: NavigationGuard = (to, from, next) => {
   const isUnavailable = import.meta.env.VITE_APP_UNAVAILABLE === 'true';
   const isUnavailablePage = to.name === 'unavailable';

   // if unavailable, redirect to unavailable page
   if (isUnavailable && !isUnavailablePage) return next({ name: 'unavailable' });

   // if available, redirect to app page
   if (!isUnavailable && isUnavailablePage) return next({ name: 'board-overview' });

   next();
};
